<template>
  <md-app md-mode="fixed">
    <md-app-drawer md-permanent="full">
      <user-sidebar ref="sidebar"></user-sidebar>
    </md-app-drawer>
    <md-app-content>
      <router-view></router-view>
    </md-app-content>
  </md-app>
</template>

<script>
  import UserSidebar from "./user/UserSidebar";

  export default {
    name      : "UserLayout",
    components: {UserSidebar},
  }
</script>

<style lang="scss" scoped>
  @import "src/assets/scss/backend.scss";
  @import "src/assets/scss/components.scss";
</style>
